module.exports = __webpack_public_path__ + "static/ux_6_2_eg-15bf77e94abec25e4a72232cfdfdd838.png";